import React from 'react';
import Lottie from 'lottie-react';
import Session from '../images/session.json';
import { Link } from 'react-router-dom';

const Expired = () => {
	return (
		<div className=' bg-red-500 h-screen flex justify-center items-center'>
			<div className=' bg-white md:w-[620px] w-[90%] h-auto shadow-2xl rounded-lg'>
				<div className=' md:p-10 p-8'>
					<Lottie animationData={Session} className='w-full' />
				</div>
				<div>
					<p className=' text-center font-bold opacity-40 text-3xl mb-4'>
						Your Licence is Expried!
					</p>
					<p className=' text-center text-lg font-semibold px-10 mb-2'>
						{' '}
						To ensure uninterrupted access, Please Contact to{' '}
						<span className=' font-bold text-red-500 text-opacity-80'>
							<Link to={'https://www.parthivisoftwares.com/'} target='#'>
								Parthivi Software and Solutions
							</Link>
						</span>{' '}
						<span className=' font-bold text-red-500 text-opacity-80'>
							<Link to={'tel:9993169171'} target='#'>
								( Contact no: 99931 69171 )
							</Link>
						</span>{' '}
						for renewal of your Licence.{' '}
					</p>
					<p className=' text-center font-semibold opacity-80 text-lg md:mb-10 mb-5'>
						Thank you for your cooperation!
					</p>
				</div>
			</div>
		</div>
	);
};

export default Expired;
